import { deleteModelo, getModelosPanel} from "../../services/ModelosServices";
import { ModelosContext } from "./ModelosContext"

export const ModelosState = ({ children }) => {
    const getModelosPanelData = async (search,numpag,filas) => {
        let res = await getModelosPanel(search,numpag,filas)
        return res
    }

    const deleteModeloData = async (body,search,numpag,filas) => {
        const res = await deleteModelo(body)
        if (res) getModelosPanelData(search,numpag,filas)
        return res
    }
    
    return <ModelosContext.Provider value={{
        deleteModeloData,
        getModelosPanelData,
    }} >
        {children}
    </ModelosContext.Provider>
}